export const DEFAULT_CLAIMS = ['Checkout', 'Upsell']